import { createFileRoute } from '@tanstack/react-router'

import CustomerPage from '@/views/customer/pages/customer.page'

export const Route = createFileRoute('/phong-nha/customer/')({
  component: CustomerPage,
})
